export default __webpack_public_path__ + "static/media/pic4.4aa28d76.jpg";